// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-toggle::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
    margin-left: 0;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #333;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
}

.dropdown-menu-right {
    right: 0;
    left: auto;
}


.dropdown-content {
    display: none;
    position: absolute;
    background-color: white;
    min-width: 260px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 3;
    left: 55px;
    top: 0;
}

/*.dropdown-content {*/
/*    display: none;*/
/*    position: absolute;*/
/*    background-color: #f1f1f1;*/
/*    min-width: 250px;*/
/*    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);*/
/*    z-index: 1;*/
/*    overflow-y: visible !important;*/
/*}*/
.dropdown-content2 {
    display: none;
    position: absolute;
    z-index: 3;
    top: -20px;
    left: 220px;
}
.dropdown-content a:not(:first-child) {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    text-align: left;

}

.dropdown-content a:hover:not(:first-child) {
    background-color: #DEFFE5;
    color: #448C58;
}

.dropdown-content a:nth-child(even) {
    background: #F9FAFA;
}

.dropdown:hover .dropdown-content {
    display: flex;
}

.dropdown2:hover .dropdown-content2 {
    display: block;
}



.dropdown-header {
    color: white;
    font-weight: bolder;
    padding: 10px 10px;
    text-decoration: none;
    display: block;
    text-align: left;
    background: #59DCC4;
}




.dropdown-content button {
    color: white;
    background: #243b77;;
    width: 100%;
    padding: 5px 5px;
    text-decoration: none;
    display: block;
}

.dropdown-content button:hover {
    background-color: #1d5a43;
}

.dropdown:hover .dropdown-content {
    display: block;
}

.dropbtn {
    /*background-color: #04AA6D;*/
    color: white;
    padding: 16px;
    font-size: 16px;
    border: none;
}

/*.dropdown:hover .dropbtn {background-color: #3e8e41;}*/


.nested-dropdowns {
    /* Border */
    border: 1px solid #d1d5db;
    display: flex;

    /* Reset list styles */
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.nested-dropdowns li {
    cursor: pointer;

    /* Spacing */
    padding: 0.25rem;

    /* Used to position the sub nested-dropdowns */
    position: relative;
}

/* The sub nested-dropdowns */
.nested-dropdowns ul {
    /* Border */
    border: 1px solid #d1d5db;

    /* Hidden by default */
    display: none;

    /* Absolute position */
    left: 0;
    position: absolute;
    top: 100%;

    /* Reset styles */
    list-style-type: none;
    margin: 0;
    padding: 0;
}

/* The second level sub nested-dropdowns */
.nested-dropdowns ul ul {
    left: 100%;
    position: absolute;
    top: 0;
}

/* Change background color of list item when being hovered */
.nested-dropdowns li:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

/* Show the direct sub nested-dropdowns when hovering the list item */
.nested-dropdowns li:hover > ul {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/static/css/dropdown-menu.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,qCAAqC;IACrC,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,qCAAqC;IACrC,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,+CAA+C;IAC/C,UAAU;IACV,UAAU;IACV,MAAM;AACV;;AAEA,sBAAsB;AACtB,qBAAqB;AACrB,0BAA0B;AAC1B,iCAAiC;AACjC,wBAAwB;AACxB,uDAAuD;AACvD,kBAAkB;AAClB,sCAAsC;AACtC,IAAI;AACJ;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;AACf;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;;;AAIA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;;;;AAKA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA,wDAAwD;;;AAGxD;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;;IAEb,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;;IAEf,YAAY;IACZ,gBAAgB;;IAEhB,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI,WAAW;IACX,yBAAyB;;IAEzB,sBAAsB;IACtB,aAAa;;IAEb,sBAAsB;IACtB,OAAO;IACP,kBAAkB;IAClB,SAAS;;IAET,iBAAiB;IACjB,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA,0CAA0C;AAC1C;IACI,UAAU;IACV,kBAAkB;IAClB,MAAM;AACV;;AAEA,4DAA4D;AAC5D;IACI,oCAAoC;AACxC;;AAEA,qEAAqE;AACrE;IACI,cAAc;AAClB","sourcesContent":[".dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n.dropdown-toggle::after {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid;\n    border-right: 0.3em solid transparent;\n    border-bottom: 0;\n    border-left: 0.3em solid transparent;\n}\n\n.dropdown-toggle:empty::after {\n    margin-left: 0;\n}\n\n.dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    display: none;\n    float: left;\n    min-width: 10rem;\n    padding: 0.5rem 0;\n    margin: 0.125rem 0 0;\n    font-size: 1rem;\n    color: #333;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 0.25rem;\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n}\n\n.dropdown-menu-right {\n    right: 0;\n    left: auto;\n}\n\n\n.dropdown-content {\n    display: none;\n    position: absolute;\n    background-color: white;\n    min-width: 260px;\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n    z-index: 3;\n    left: 55px;\n    top: 0;\n}\n\n/*.dropdown-content {*/\n/*    display: none;*/\n/*    position: absolute;*/\n/*    background-color: #f1f1f1;*/\n/*    min-width: 250px;*/\n/*    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);*/\n/*    z-index: 1;*/\n/*    overflow-y: visible !important;*/\n/*}*/\n.dropdown-content2 {\n    display: none;\n    position: absolute;\n    z-index: 3;\n    top: -20px;\n    left: 220px;\n}\n.dropdown-content a:not(:first-child) {\n    color: black;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n    text-align: left;\n\n}\n\n.dropdown-content a:hover:not(:first-child) {\n    background-color: #DEFFE5;\n    color: #448C58;\n}\n\n.dropdown-content a:nth-child(even) {\n    background: #F9FAFA;\n}\n\n.dropdown:hover .dropdown-content {\n    display: flex;\n}\n\n.dropdown2:hover .dropdown-content2 {\n    display: block;\n}\n\n\n\n.dropdown-header {\n    color: white;\n    font-weight: bolder;\n    padding: 10px 10px;\n    text-decoration: none;\n    display: block;\n    text-align: left;\n    background: #59DCC4;\n}\n\n\n\n\n.dropdown-content button {\n    color: white;\n    background: #243b77;;\n    width: 100%;\n    padding: 5px 5px;\n    text-decoration: none;\n    display: block;\n}\n\n.dropdown-content button:hover {\n    background-color: #1d5a43;\n}\n\n.dropdown:hover .dropdown-content {\n    display: block;\n}\n\n.dropbtn {\n    /*background-color: #04AA6D;*/\n    color: white;\n    padding: 16px;\n    font-size: 16px;\n    border: none;\n}\n\n/*.dropdown:hover .dropbtn {background-color: #3e8e41;}*/\n\n\n.nested-dropdowns {\n    /* Border */\n    border: 1px solid #d1d5db;\n    display: flex;\n\n    /* Reset list styles */\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n.nested-dropdowns li {\n    cursor: pointer;\n\n    /* Spacing */\n    padding: 0.25rem;\n\n    /* Used to position the sub nested-dropdowns */\n    position: relative;\n}\n\n/* The sub nested-dropdowns */\n.nested-dropdowns ul {\n    /* Border */\n    border: 1px solid #d1d5db;\n\n    /* Hidden by default */\n    display: none;\n\n    /* Absolute position */\n    left: 0;\n    position: absolute;\n    top: 100%;\n\n    /* Reset styles */\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n/* The second level sub nested-dropdowns */\n.nested-dropdowns ul ul {\n    left: 100%;\n    position: absolute;\n    top: 0;\n}\n\n/* Change background color of list item when being hovered */\n.nested-dropdowns li:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n/* Show the direct sub nested-dropdowns when hovering the list item */\n.nested-dropdowns li:hover > ul {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
